var map = {
	"./AgendaIcon.vue": 69334,
	"./AlertCircleIcon.vue": 98848,
	"./ArrowRightIcon.vue": 20224,
	"./BugFixIcon.vue": 61142,
	"./CalendarIcon.vue": 69133,
	"./ChevronDownIcon.vue": 54612,
	"./ChevronLeftIcon.vue": 54170,
	"./ChevronRightIcon.vue": 61699,
	"./ChevronUpIcon.vue": 8214,
	"./CircleCheckIcon.vue": 98832,
	"./CircleXIcon.vue": 53577,
	"./DangerSignIcon.vue": 97143,
	"./DashboardIcon.vue": 14096,
	"./DocumentIcon.vue": 27309,
	"./DotsIcon.vue": 10357,
	"./DownloadActiveIcon.vue": 18030,
	"./DownloadIcon.vue": 55959,
	"./EyeIcon.vue": 29268,
	"./EyeOffIcon.vue": 20255,
	"./FileTextIcon.vue": 17558,
	"./FilterIcon.vue": 42088,
	"./FilterUpIcon.vue": 23741,
	"./HandshakeIcon.vue": 67003,
	"./ImprovementsIcon.vue": 56125,
	"./InfoCircleIcon.vue": 6626,
	"./LockIcon.vue": 7370,
	"./MailIcon.vue": 40062,
	"./MaintenanceIcon.vue": 69227,
	"./NewFeatureIcon.vue": 77409,
	"./NotificationsActiveIcon.vue": 55610,
	"./NotificationsIcon.vue": 44069,
	"./PencilIcon.vue": 36108,
	"./PieChartIcon.vue": 16595,
	"./PlusIcon.vue": 55194,
	"./RefreshIcon.vue": 43369,
	"./ReportIcon.vue": 42267,
	"./SearchIcon.vue": 42368,
	"./SettingsIcon.vue": 14624,
	"./StarFullIcon.vue": 5265,
	"./StarIcon.vue": 84047,
	"./SuccessIcon.vue": 25454,
	"./TradeIcon.vue": 11264,
	"./TrainingIcon.vue": 27773,
	"./TrashIcon.vue": 9032,
	"./UpdatesActiveIcon.vue": 86808,
	"./UpdatesIcon.vue": 70278,
	"./UploadIcon.vue": 30057,
	"./UserIcon.vue": 50318,
	"./WalletIcon.vue": 56091,
	"./XIcon.vue": 1453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47590;